import type { RootState } from '@oneview/redux/rootReducer';
import { createSelector } from '@reduxjs/toolkit';

export const selectTrading = (state: RootState) => state.trading;

export const selectSavedCommissionState = createSelector(selectTrading, (trading) => trading.savedCommissionState);
